import { Link } from '@remix-run/react';

import { Image } from '~/components/Image';
import Text from '~/components/Text';

interface Props {
  url: string;
  name: string;
}

const LogoHome = ({ url, name }: Props) => {
  return (
    <Link className="transition:all rounded-wt px-2 py-1 hover:bg-black/5" to="/">
      <div className="flex items-center space-x-2">
        {url && (
          <div className="h-8 w-8 overflow-hidden rounded-wt">
            <Image
              className="h-full w-full rounded-wt object-contain"
              src={url}
              alt={`${name} logo`}
              maxWidth={100}
              aspectRatio="square"
            />
          </div>
        )}
        <Text as="span" type="title" theme="navs" className="sm:text-md wt-text-primary hidden text-sm sm:block">
          {name}
        </Text>
      </div>
    </Link>
  );
};

export default LogoHome;
